import { memoize, partition } from '@exodus/basic-utils';
import { ALLOWED_AMOUNTS_DIFF_PERCENTAGE, MEMOIZE_DUMMY_RESOLVER, MEMOIZE_SESSION_TIMEOUT, } from './constants';
export const deconstructPairId = (pairId) => {
    try {
        const match = pairId.match(/^(\w{1,60})_(\w{1,60})$/u);
        if (match) {
            const [_, from, to] = match;
            return { from: from, to: to };
        }
        return { from: '', to: '' };
    }
    catch {
        return { from: '', to: '' };
    }
};
export const getPairFromPairId = (pairId) => {
    const { from, to } = deconstructPairId(pairId);
    return { from, to, id: pairId };
};
export const fulfilledValues = async (promises, { logger } = {}) => {
    const results = await Promise.allSettled(promises);
    const [fulfilled, failed] = partition(results, (result) => result.status === 'fulfilled');
    failed.forEach((result) => {
        logger?.debug(`Promise failed: ${result.reason}`);
    });
    return fulfilled.map((result) => result.value);
};
export const areAmountsValid = (amount1, amount2) => {
    const difference = Math.abs(Number(amount1) - Number(amount2));
    const percentOfLarger = (Math.max(Number(amount1), Number(amount2)) * ALLOWED_AMOUNTS_DIFF_PERCENTAGE) / 100;
    return difference <= percentOfLarger;
};
export const getGeolocationKey = (geolocation) => `${geolocation.countryCode}`;
export const memoizeWithTimeout = (fn, resolver = MEMOIZE_DUMMY_RESOLVER, timeout) => {
    return memoize(fn, resolver, timeout || MEMOIZE_SESSION_TIMEOUT);
};
